import { useState, useCallback } from "react";
import { StripeEmbeddedCheckout } from "@/components/StripeEmbeddedCheckout";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { trackEvent, ANALYTICS_EVENTS } from "@/lib/analytics";

interface CheckoutOptions {
  priceId?: string;
  trendId?: string;
  customerEmail?: string;
  userId?: string;
  returnUrl: string;
}

export function useStripeCheckout() {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<CheckoutOptions | null>(null);

  const openCheckout = useCallback((opts: CheckoutOptions) => {
    trackEvent(ANALYTICS_EVENTS.CHECKOUT_STARTED, { priceId: opts.priceId ?? `blueprint:${opts.trendId ?? ""}` });
    setOptions(opts);
    setIsOpen(true);
  }, []);

  const closeCheckout = useCallback(() => {
    setIsOpen(false);
    setOptions(null);
  }, []);

  const checkoutElement = isOpen && options ? (
    <Dialog open={isOpen} onOpenChange={(v) => !v && closeCheckout()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto p-0">
        <StripeEmbeddedCheckout {...options} />
      </DialogContent>
    </Dialog>
  ) : null;

  return { openCheckout, closeCheckout, isOpen, checkoutElement };
}
